module.exports = __webpack_public_path__ + "img/text-logo.2a19dd0a.png";